import CryptoJS from 'crypto-js'; //引用AES源码js

const defaultKeyStr = "1234123412ABCDEF";//密钥
const defaultIvStr = "ABCDEF1234123412";//密钥偏移量
const defaultKey = CryptoJS.enc.Utf8.parse(defaultKeyStr);
const defaultIv = CryptoJS.enc.Utf8.parse(defaultIvStr);

/**
 * 获取key
 * @param keyStr key字符串
 */
function getKey(keyStr) {
    if (keyStr) {
        return CryptoJS.enc.Utf8.parse(keyStr);
    }
    return defaultKey;
}

/**
 * 获取iv
 * @param ivStr iv字符串
 * @returns {*}
 */
function getIv(ivStr) {
    if (ivStr) {
        return CryptoJS.enc.Utf8.parse(ivStr);
    }
    return defaultIv;
}

/**
 * 加密方法
 * @param word 加密字符串
 * @param keyStr 秘钥
 * @param ivStr 秘钥偏移量
 * @returns {string}
 */
export const encrypt = (word, keyStr, ivStr) => {
    let key = getKey(keyStr);
    let iv = getIv(ivStr);
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString().toUpperCase();
    // 如果不需要解密.ciphertext.toString().toUpperCase();将这段代码删除
}

/**
 * 解密方法
 * @param word 解密字符串
 * @param keyStr 秘钥
 * @param ivStr 秘钥偏移量
 * @returns {string}
 */
export const decrypt = (word, keyStr, ivStr) => {
    let key = getKey(keyStr);
    let iv = getIv(ivStr);

    let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    let decrypt = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}
